import React, { useEffect, useState } from "react";
import { fetchProfileForSeekerAwardsThree } from "../API/api";
import { useLocation, useNavigate } from "react-router-dom";
import { emailRedirection } from "../utils";
import { BASE_URL, UI_BASE_URL, CURRENT_ROLE } from "../API/url";

const AUTH_TRANSIT_PATHS = [
  "/login_error",
  "/auth_error",
  "/login/authenticated",
  "/uptime",
];

// Maps the home-path prefix of each role to the role name itself, so we can
// tell which role a given deep link belongs to, e.g. /cmHome/... -> "CM".
const ROLE_HOME_PREFIXES = {
  "/seekerHome": "Seeker",
  "/expertHome": "Expert",
  "/cmHome": "CM",
  "/adminhome": "Admin",
  "/emailHome": "Emails",
};

export default function useAuthentication(dispatchFunc) {
  const navigate = useNavigate();
  const currentPath = useLocation();
  useEffect(() => {
    // Login/auth "plumbing" routes (SSO callback, error pages, etc.) can carry their
    // own unrelated query strings. Don't let landing on one of those wipe out the
    // deep-link params/path we captured on the way in.
    const isAuthTransitPath = AUTH_TRANSIT_PATHS.some((p) =>
      currentPath.pathname.includes(p),
    );

    const params = new URLSearchParams(window.location.search);
    const allParams = Object.fromEntries(params.entries());
    console.log(allParams);

    if (!isAuthTransitPath) {
      localStorage.setItem(
        "queryParams",
        new URLSearchParams(allParams).toString(),
      );
    }
    const handleAuthentication = () => {
      let jsessionid = localStorage.getItem("JSESSIONID");
      let paramExist = localStorage.getItem("queryParams");
      if (currentPath.pathname.includes("/uptime")) {
        navigate("/uptime");
        return;
      }
      if (
        currentPath.pathname.includes("/login_error") &&
        jsessionid === null
      ) {
        navigate("/login_error");
        return;
      }
      if (currentPath.pathname.includes("/auth_error") && jsessionid === null) {
        navigate("/auth_error");
        return;
      }
      if (currentPath.pathname.includes("login/authenticated")) {
        return;
      }
      if (jsessionid === null) {
        // Preserve the exact page the user was trying to reach (e.g. a path-based
        // deep link from an email like /cmHome/expertrecordDetail/<id>/<type>) so
        // we can send them there after they log in, instead of the homepage.
        // Skip this on /login itself and on the auth transit routes above.
        if (!isAuthTransitPath && currentPath.pathname !== "/login") {
          localStorage.setItem(
            "postLoginRedirect",
            currentPath.pathname + window.location.search,
          );
        }
        if (process.env.REACT_APP_MY_SSO === "true") {
          window.location.href =
            BASE_URL +
            `/saml/login${paramExist === null ? "" : "?" + paramExist}`;
        } else if (process.env.REACT_APP_MY_NATIVE === "true") {
          navigate("/login");
        } else if (process.env.REACT_APP_MY_SSO === "true") {
          window.location.href =
            BASE_URL +
            `/saml/login${paramExist === null ? "" : "?" + paramExist}`;
        } else if (process.env.REACT_APP_MY_OAUTH === "true") {
          window.location.href = `${BASE_URL}/oauth2/authorization/google${paramExist === null ? "" : "?" + paramExist}`;
        } else if (process.env.REACT_APP_MY_SHOWPAD === "true") {
          window.location.href = `${BASE_URL}/oauth2/authorization/showpad${paramExist === null ? "" : "?" + paramExist}`;
        }
        return;
      }
      if (paramExist === "" || paramExist === null) {
        fetchProfileForSeekerAwardsThree()?.then((res) => {
          dispatchFunc(res?.data?.data);

          // The current path might belong to a role other than the one
          // that's active right now (e.g. active role is Seeker, but the
          // link is a /cmHome/... deep link). If the account actually holds
          // that other role, switch to it and reload to the same path so
          // the router renders it with the right role active, instead of
          // falling back to the active role's homepage.
          const roleArr = res?.data?.data?.roles?.map((r) => r.roleName) || [];
          console.log("roleArr:", roleArr);
          const targetPrefix = Object.keys(ROLE_HOME_PREFIXES).find((prefix) =>
            currentPath.pathname.toLowerCase().startsWith(prefix.toLowerCase()),
          );
          console.log("targetPrefix:", targetPrefix);

          const targetRole = targetPrefix
            ? ROLE_HOME_PREFIXES[targetPrefix]
            : null;
          console.log("targetRole:", targetRole);

          if (
            targetRole &&
            targetRole !== CURRENT_ROLE &&
            roleArr.includes(targetRole)
          ) {
            localStorage.setItem(
              "ngStorage-currentRole",
              JSON.stringify(targetRole),
            );
            window.location.href = `${UI_BASE_URL}${currentPath.pathname}${window.location.search}`;
          }
        });
      } else {
        emailRedirection(paramExist);
      }
    };

    handleAuthentication();
  }, []);
}
